/**
 * 自用蓝主题 — 颜色与设计令牌
 * 来源：Figma「收银台 (自用主题)」
 */
export default {
  // 主色（深蓝）
  primary: '#17325B',
  primaryLight: '#233E6F',
  primaryBright: '#1252BE',
  primaryDeep: '#081F43',
  primaryNavy: '#0C2B59',
  primaryNavyDark: '#0C246F',
  primaryHighlight: '#EAA03A',

  // 文字蓝
  textBlue: '#919EED',
  textBlueLight: '#B1BAF0',
  textBlueMuted: '#949ED9',

  // 按钮
  btnText: '#EAA03A',
  btnTextAlt: '#E68608',
  btnGradientStart: '#233E6F',
  btnGradientEnd: '#081F43',
  btnStrongGradientStart: '#233E6F',
  btnStrongGradientEnd: '#17325B',
  btnStrongGradientEnd2: '#081F43',
  btnAccentText: '#EAA03A',

  // 复制 / 强调
  accentYellow: '#EAA03A',
  accentYellowDark: '#E68608',

  // 边框
  borderGold: '#1D3B85',
  borderAccent: '#EAA03A',
  borderGray: '#D6D8DE',
  borderLight: '#E8EFFA',
  borderLighter: '#EDF0F7',
  borderInput: '#D6D8DE',

  // 文字
  textPrimary: '#0C2B59',
  textSecondary: '#2E2372',
  textMuted: '#6D7CA9',
  textDisabled: '#C9CEED',
  textBrownDark: '#0C246F',
  textBrown: '#6D7CA9',
  textBrownLight: '#919EED',
  textBrownMuted: '#949ED9',
  textTitle: '#0C246F',
  textPlaceholder: '#D6D8DE',
  textGray: '#6D7CA9',
  textDark: '#0C246F',

  // 状态色
  success: '#029B00',
  danger: '#A13D46',
  dangerBg: '#F8F1F2',
  dangerBorder: '#EFE0E3',
  tipsRed: '#A13D46',
  amountRed: '#EAA03A',
  errorRed: '#A13D46',

  // 背景
  bgPage: '#FFFFFF',
  bgPageNavy: '#FFFFFF',
  bgCard: '#FFFFFF',
  bgSecondary: '#F4F5F8',
  bgInput: '#FFFFFF',
  bgStripe: '#F6F9FF',
  bgOverlay: 'rgba(23, 61, 136, 0.15)',
  bgBadge: 'rgba(255, 255, 255, 0.15)',
  bgGlass: '#FEFEFF',

  // 头部区域
  headerText: '#0C2B59',
  headerSubText: '#0C2B59',
  headerMutedText: '#6D7CA9',

  // 其他
  white: '#FFFFFF',
  disabled: '#C9CEED',
  smsBtn: '#1252BE',
  pendingDesc: '#949ED9',
  copyBtn: '#17325B',
  tipsColor: '#A13D46',
};
